import { Receipt } from 'lucide-react';
import { Link } from 'react-router-dom';

export function BillsPage() {
  return (
    <div className="mx-auto max-w-4xl space-y-6 p-4">
      <div className="flex items-center justify-between">
        <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-900">
          <Receipt className="h-8 w-8 text-blue-600" />
          Vendor bills
        </h1>
        <Link to="/dashboard" className="text-sm font-medium text-blue-600 hover:underline">
          ← Dashboard
        </Link>
      </div>
      <p className="text-slate-600">
        Bulk upload bills with OCR. Production flow uses <code className="rounded bg-slate-100 px-1">POST /api/process-bill</code> (R2 + OpenAI).
      </p>
      <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-12 text-center text-slate-500">
        Drop bills here (UI placeholder) — wire file input to worker when R2 is configured.
      </div>
    </div>
  );
}
